import { Component, computed, inject, Input, input } from '@angular/core';
import { SocketService, DraftHistoryEntry } from '../../../../services/socket';
import { PlayerCard, PlayerCardData } from '../../../../components/player-card/player-card';

@Component({
  selector: 'app-the-tape',
  imports: [PlayerCard],
  templateUrl: './the-tape.html',
  styleUrl: './the-tape.css',
})
export class TheTape {
  @Input() collapsed = false;
  isCommissioner = input(false);
  leagueId = input<number | null>(null);
  private socketService = inject(SocketService);

  tapePlayers = computed<DraftHistoryEntry[]>(() => {
    const history = this.socketService.draftSettings()?.draftHistory ?? [];
    return [...history].sort((a, b) => b.draft_position - a.draft_position);
  });

  cardData(e: DraftHistoryEntry): PlayerCardData {
    return { firstName: e.first_name, lastName: e.last_name, position: e.position, team: e.pro_team, photo: e.photo, cost: e.cost };
  }

  undraftPlayer(entry: DraftHistoryEntry): void {
    const id = this.leagueId();
    if (!id) return;
    if (confirm(`Remove ${entry.first_name} ${entry.last_name} from ${entry.team_name}?`)) {
      this.socketService.undraftPlayer(id, entry.player_id);
    }
  }
}
